import { useDarkMode } from "../../../context/ThemeContext";

export default function ResumenSection() {
  const { isDarkMode } = useDarkMode();

  const themeClasses = {
    bg: isDarkMode ? "bg-dark-bg" : "bg-white",
    text: isDarkMode ? "text-white" : "text-gray-900",
    textSecondary: isDarkMode ? "text-gray-400" : "text-gray-600",
    cardBg: isDarkMode ? "bg-dark-surface" : "bg-white",
    cardBorder: isDarkMode ? "border-dark-border" : "border-gray-200",
  };

  return (
    <div className="w-full h-full p-6 overflow-auto">
      <div className="mb-6">
        <h1 className={`text-2xl font-bold ${themeClasses.text}`}>
          Resumen de Cobranza
        </h1>
        <p className={`text-sm ${themeClasses.textSecondary} mt-1`}>
          Vista general del estado de pagos y adeudos
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {/* Placeholder cards */}
        <div className={`${themeClasses.cardBg} border ${themeClasses.cardBorder} rounded-xl p-6`}>
          <div className="flex items-center justify-between mb-4">
            <h3 className={`text-lg font-semibold ${themeClasses.text}`}>Pagos del mes</h3>
            <i className="ri-money-dollar-circle-line text-2xl text-emerald-500"></i>
          </div>
          <p className={`text-3xl font-bold ${themeClasses.text}`}>$0.00</p>
          <p className={`text-sm ${themeClasses.textSecondary} mt-1`}>0 pagos recibidos</p>
        </div>

        <div className={`${themeClasses.cardBg} border ${themeClasses.cardBorder} rounded-xl p-6`}>
          <div className="flex items-center justify-between mb-4">
            <h3 className={`text-lg font-semibold ${themeClasses.text}`}>Adeudos pendientes</h3>
            <i className="ri-file-warning-line text-2xl text-amber-500"></i>
          </div>
          <p className={`text-3xl font-bold ${themeClasses.text}`}>$0.00</p>
          <p className={`text-sm ${themeClasses.textSecondary} mt-1`}>0 cuentas pendientes</p>
        </div>

        <div className={`${themeClasses.cardBg} border ${themeClasses.cardBorder} rounded-xl p-6`}>
          <div className="flex items-center justify-between mb-4">
            <h3 className={`text-lg font-semibold ${themeClasses.text}`}>Vencidos</h3>
            <i className="ri-error-warning-line text-2xl text-red-500"></i>
          </div>
          <p className={`text-3xl font-bold ${themeClasses.text}`}>$0.00</p>
          <p className={`text-sm ${themeClasses.textSecondary} mt-1`}>0 pagos vencidos</p>
        </div>
      </div>

      <div className={`mt-6 ${themeClasses.cardBg} border ${themeClasses.cardBorder} rounded-xl p-6`}>
        <div className="flex items-center justify-center py-12">
          <div className="text-center">
            <i className={`ri-pie-chart-line text-6xl ${themeClasses.textSecondary} mb-4`}></i>
            <p className={`text-lg ${themeClasses.textSecondary}`}>
              Selecciona una compañía para ver el resumen de cobranza
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
